import React, { useEffect, useState } from "react";
import { useGetEntityTasksQuery } from "store/apis/task";
import { TaskCard } from "./TaskCard";
import { FORM_FILING_TYPE } from "constants/taskStates";
import { useDispatch, useSelector } from "react-redux";
import { setIsValidForm } from "store/slices/task";
import { RootState } from "store/store";

const PUBLIC_5471_BASE_TASK_TEMPLATE_ID =
  process.env.PUBLIC_5471_BASE_TASK_TEMPLATE_ID;
const PUBLIC_5472_BASE_TASK_TEMPLATE_ID =
  process.env.PUBLIC_5472_BASE_TASK_TEMPLATE_ID;
const baseTaskTemplateUuids = [
  PUBLIC_5471_BASE_TASK_TEMPLATE_ID,
  PUBLIC_5472_BASE_TASK_TEMPLATE_ID,
];

export const LinkedFilings = ({
  entityId,
  season,
}: {
  entityId: string;
  season: string;
}) => {
  const { data = [], isSuccess } = useGetEntityTasksQuery({
    entityId,
    season,
    base_task_template_uuids: baseTaskTemplateUuids.join(","),
  });
  const dispatch = useDispatch();
  const [invalidFilings, setInvalidFilings] = useState<string[]>([]);
  const isFormSubmitClicked = useSelector(
    (state: RootState) => state.taskSlice.isFormSubmitClicked
  );
  useEffect(() => {
    const invalidForms = data
      .filter(
        (task) => !task.state_type || task.state_type === FORM_FILING_TYPE
      )
      .map((task) => task.uuid);
    setInvalidFilings(invalidForms);
    dispatch(setIsValidForm(invalidForms.length === 0));
  }, [data.length]);

  if (isSuccess && (!data || data?.length === 0)) {
    return (
      <div className="t-text-body-sm t-text-text-30 -t-mt-5">
        No Forms 5471 or 5472 launched. You can proceed with Form 1120 if you
        don't have foreign subsidiaries or foreign shareholders with over 20%
        ownership. If you do, please let our team know in the chat.
      </div>
    );
  }

  return (
    <div>
      <div className="t-mb-5 t-text-body-sm t-text-text-30 -t-mt-5">
        To file Form 1120, your business must complete the required forms below
        for foreign entity reporting
      </div>
      <div className="t-space-y-4">
        {data?.map((task, index) => {
          const isInvalid =
            isFormSubmitClicked && invalidFilings.includes(task.uuid);
          return <TaskCard task={task} key={index} isInvalid={isInvalid} />;
        })}
      </div>
    </div>
  );
};

export default LinkedFilings;
